/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as LogbookRouteImport } from './routes/logbook'
import { Route as PcRouteImport } from './routes/pc'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as TransfersRouteImport } from './routes/transfers'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AirframesIndexRouteImport } from './routes/airframes.index'
import { Route as AirframesIdRouteImport } from './routes/airframes.$id'
import { Route as InvitesCodeRouteImport } from './routes/invites.$code'
import { Route as PcIndexRouteImport } from './routes/pc.index'
import { Route as PcLogRouteImport } from './routes/pc.log'
import { Route as PcReturnsRouteImport } from './routes/pc.returns'
import { Route as PcSettingsRouteImport } from './routes/pc.settings'
import { Route as AirframesIdIndexRouteImport } from './routes/airframes.$id.index'
import { Route as AirframesIdHistoryRouteImport } from './routes/airframes.$id.history'
import { Route as AirframesIdLedgerRouteImport } from './routes/airframes.$id.ledger'
import { Route as AirframesIdMaintenanceRouteImport } from './routes/airframes.$id.maintenance'
import { Route as AirframesIdMembersRouteImport } from './routes/airframes.$id.members'
import { Route as AirframesIdPreflightRouteImport } from './routes/airframes.$id.preflight'
import { Route as AirframesIdScheduleRouteImport } from './routes/airframes.$id.schedule'
import { Route as AirframesIdSettingsRouteImport } from './routes/airframes.$id.settings'
import { Route as AirframesIdFlightsFidRouteImport } from './routes/airframes.$id.flights.$fid'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const LogbookRoute = LogbookRouteImport.update({
  id: '/logbook',
  path: '/logbook',
  getParentRoute: () => rootRouteImport,
} as any)
const PcRoute = PcRouteImport.update({
  id: '/pc',
  path: '/pc',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const TransfersRoute = TransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AirframesIndexRoute = AirframesIndexRouteImport.update({
  id: '/airframes/',
  path: '/airframes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AirframesIdRoute = AirframesIdRouteImport.update({
  id: '/airframes/$id',
  path: '/airframes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesCodeRoute = InvitesCodeRouteImport.update({
  id: '/invites/$code',
  path: '/invites/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const PcIndexRoute = PcIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PcRoute,
} as any)
const PcLogRoute = PcLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => PcRoute,
} as any)
const PcReturnsRoute = PcReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => PcRoute,
} as any)
const PcSettingsRoute = PcSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PcRoute,
} as any)
const AirframesIdIndexRoute = AirframesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdHistoryRoute = AirframesIdHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdLedgerRoute = AirframesIdLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdMaintenanceRoute = AirframesIdMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdMembersRoute = AirframesIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdPreflightRoute = AirframesIdPreflightRouteImport.update({
  id: '/preflight',
  path: '/preflight',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdScheduleRoute = AirframesIdScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdSettingsRoute = AirframesIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AirframesIdRoute,
} as any)
const AirframesIdFlightsFidRoute = AirframesIdFlightsFidRouteImport.update({
  id: '/flights/$fid',
  path: '/flights/$fid',
  getParentRoute: () => AirframesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/guide': typeof GuideRoute
  '/logbook': typeof LogbookRoute
  '/pc': typeof PcRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/transfers': typeof TransfersRoute
  '/welcome': typeof WelcomeRoute
  '/airframes/$id': typeof AirframesIdRouteWithChildren
  '/invites/$code': typeof InvitesCodeRoute
  '/pc/log': typeof PcLogRoute
  '/pc/returns': typeof PcReturnsRoute
  '/pc/settings': typeof PcSettingsRoute
  '/airframes/': typeof AirframesIndexRoute
  '/pc/': typeof PcIndexRoute
  '/airframes/$id/history': typeof AirframesIdHistoryRoute
  '/airframes/$id/ledger': typeof AirframesIdLedgerRoute
  '/airframes/$id/maintenance': typeof AirframesIdMaintenanceRoute
  '/airframes/$id/members': typeof AirframesIdMembersRoute
  '/airframes/$id/preflight': typeof AirframesIdPreflightRoute
  '/airframes/$id/schedule': typeof AirframesIdScheduleRoute
  '/airframes/$id/settings': typeof AirframesIdSettingsRoute
  '/airframes/$id/': typeof AirframesIdIndexRoute
  '/airframes/$id/flights/$fid': typeof AirframesIdFlightsFidRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/guide': typeof GuideRoute
  '/logbook': typeof LogbookRoute
  '/privacy': typeof PrivacyRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/transfers': typeof TransfersRoute
  '/welcome': typeof WelcomeRoute
  '/invites/$code': typeof InvitesCodeRoute
  '/pc/log': typeof PcLogRoute
  '/pc/returns': typeof PcReturnsRoute
  '/pc/settings': typeof PcSettingsRoute
  '/airframes': typeof AirframesIndexRoute
  '/pc': typeof PcIndexRoute
  '/airframes/$id/history': typeof AirframesIdHistoryRoute
  '/airframes/$id/ledger': typeof AirframesIdLedgerRoute
  '/airframes/$id/maintenance': typeof AirframesIdMaintenanceRoute
  '/airframes/$id/members': typeof AirframesIdMembersRoute
  '/airframes/$id/preflight': typeof AirframesIdPreflightRoute
  '/airframes/$id/schedule': typeof AirframesIdScheduleRoute
  '/airframes/$id/settings': typeof AirframesIdSettingsRoute
  '/airframes/$id': typeof AirframesIdIndexRoute
  '/airframes/$id/flights/$fid': typeof AirframesIdFlightsFidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/guide': typeof GuideRoute
  '/logbook': typeof LogbookRoute
  '/pc': typeof PcRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/transfers': typeof TransfersRoute
  '/welcome': typeof WelcomeRoute
  '/airframes/$id': typeof AirframesIdRouteWithChildren
  '/invites/$code': typeof InvitesCodeRoute
  '/pc/log': typeof PcLogRoute
  '/pc/returns': typeof PcReturnsRoute
  '/pc/settings': typeof PcSettingsRoute
  '/airframes/': typeof AirframesIndexRoute
  '/pc/': typeof PcIndexRoute
  '/airframes/$id/history': typeof AirframesIdHistoryRoute
  '/airframes/$id/ledger': typeof AirframesIdLedgerRoute
  '/airframes/$id/maintenance': typeof AirframesIdMaintenanceRoute
  '/airframes/$id/members': typeof AirframesIdMembersRoute
  '/airframes/$id/preflight': typeof AirframesIdPreflightRoute
  '/airframes/$id/schedule': typeof AirframesIdScheduleRoute
  '/airframes/$id/settings': typeof AirframesIdSettingsRoute
  '/airframes/$id/': typeof AirframesIdIndexRoute
  '/airframes/$id/flights/$fid': typeof AirframesIdFlightsFidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/guide'
    | '/logbook'
    | '/pc'
    | '/privacy'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/transfers'
    | '/welcome'
    | '/airframes/$id'
    | '/invites/$code'
    | '/pc/log'
    | '/pc/returns'
    | '/pc/settings'
    | '/airframes/'
    | '/pc/'
    | '/airframes/$id/history'
    | '/airframes/$id/ledger'
    | '/airframes/$id/maintenance'
    | '/airframes/$id/members'
    | '/airframes/$id/preflight'
    | '/airframes/$id/schedule'
    | '/airframes/$id/settings'
    | '/airframes/$id/'
    | '/airframes/$id/flights/$fid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/admin'
    | '/guide'
    | '/logbook'
    | '/privacy'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/transfers'
    | '/welcome'
    | '/invites/$code'
    | '/pc/log'
    | '/pc/returns'
    | '/pc/settings'
    | '/airframes'
    | '/pc'
    | '/airframes/$id/history'
    | '/airframes/$id/ledger'
    | '/airframes/$id/maintenance'
    | '/airframes/$id/members'
    | '/airframes/$id/preflight'
    | '/airframes/$id/schedule'
    | '/airframes/$id/settings'
    | '/airframes/$id'
    | '/airframes/$id/flights/$fid'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/guide'
    | '/logbook'
    | '/pc'
    | '/privacy'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/transfers'
    | '/welcome'
    | '/airframes/$id'
    | '/invites/$code'
    | '/pc/log'
    | '/pc/returns'
    | '/pc/settings'
    | '/airframes/'
    | '/pc/'
    | '/airframes/$id/history'
    | '/airframes/$id/ledger'
    | '/airframes/$id/maintenance'
    | '/airframes/$id/members'
    | '/airframes/$id/preflight'
    | '/airframes/$id/schedule'
    | '/airframes/$id/settings'
    | '/airframes/$id/'
    | '/airframes/$id/flights/$fid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRoute
  GuideRoute: typeof GuideRoute
  LogbookRoute: typeof LogbookRoute
  PcRoute: typeof PcRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  ScheduleRoute: typeof ScheduleRoute
  SettingsRoute: typeof SettingsRoute
  SetupRoute: typeof SetupRoute
  TransfersRoute: typeof TransfersRoute
  WelcomeRoute: typeof WelcomeRoute
  AirframesIdRoute: typeof AirframesIdRouteWithChildren
  InvitesCodeRoute: typeof InvitesCodeRoute
  AirframesIndexRoute: typeof AirframesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook': {
      id: '/logbook'
      path: '/logbook'
      fullPath: '/logbook'
      preLoaderRoute: typeof LogbookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pc': {
      id: '/pc'
      path: '/pc'
      fullPath: '/pc'
      preLoaderRoute: typeof PcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transfers': {
      id: '/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof TransfersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/airframes/': {
      id: '/airframes/'
      path: '/airframes'
      fullPath: '/airframes/'
      preLoaderRoute: typeof AirframesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/airframes/$id': {
      id: '/airframes/$id'
      path: '/airframes/$id'
      fullPath: '/airframes/$id'
      preLoaderRoute: typeof AirframesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$code': {
      id: '/invites/$code'
      path: '/invites/$code'
      fullPath: '/invites/$code'
      preLoaderRoute: typeof InvitesCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pc/': {
      id: '/pc/'
      path: '/'
      fullPath: '/pc/'
      preLoaderRoute: typeof PcIndexRouteImport
      parentRoute: typeof PcRoute
    }
    '/pc/log': {
      id: '/pc/log'
      path: '/log'
      fullPath: '/pc/log'
      preLoaderRoute: typeof PcLogRouteImport
      parentRoute: typeof PcRoute
    }
    '/pc/returns': {
      id: '/pc/returns'
      path: '/returns'
      fullPath: '/pc/returns'
      preLoaderRoute: typeof PcReturnsRouteImport
      parentRoute: typeof PcRoute
    }
    '/pc/settings': {
      id: '/pc/settings'
      path: '/settings'
      fullPath: '/pc/settings'
      preLoaderRoute: typeof PcSettingsRouteImport
      parentRoute: typeof PcRoute
    }
    '/airframes/$id/': {
      id: '/airframes/$id/'
      path: '/'
      fullPath: '/airframes/$id/'
      preLoaderRoute: typeof AirframesIdIndexRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/history': {
      id: '/airframes/$id/history'
      path: '/history'
      fullPath: '/airframes/$id/history'
      preLoaderRoute: typeof AirframesIdHistoryRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/ledger': {
      id: '/airframes/$id/ledger'
      path: '/ledger'
      fullPath: '/airframes/$id/ledger'
      preLoaderRoute: typeof AirframesIdLedgerRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/maintenance': {
      id: '/airframes/$id/maintenance'
      path: '/maintenance'
      fullPath: '/airframes/$id/maintenance'
      preLoaderRoute: typeof AirframesIdMaintenanceRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/members': {
      id: '/airframes/$id/members'
      path: '/members'
      fullPath: '/airframes/$id/members'
      preLoaderRoute: typeof AirframesIdMembersRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/preflight': {
      id: '/airframes/$id/preflight'
      path: '/preflight'
      fullPath: '/airframes/$id/preflight'
      preLoaderRoute: typeof AirframesIdPreflightRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/schedule': {
      id: '/airframes/$id/schedule'
      path: '/schedule'
      fullPath: '/airframes/$id/schedule'
      preLoaderRoute: typeof AirframesIdScheduleRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/settings': {
      id: '/airframes/$id/settings'
      path: '/settings'
      fullPath: '/airframes/$id/settings'
      preLoaderRoute: typeof AirframesIdSettingsRouteImport
      parentRoute: typeof AirframesIdRoute
    }
    '/airframes/$id/flights/$fid': {
      id: '/airframes/$id/flights/$fid'
      path: '/flights/$fid'
      fullPath: '/airframes/$id/flights/$fid'
      preLoaderRoute: typeof AirframesIdFlightsFidRouteImport
      parentRoute: typeof AirframesIdRoute
    }
  }
}

interface PcRouteChildren {
  PcLogRoute: typeof PcLogRoute
  PcReturnsRoute: typeof PcReturnsRoute
  PcSettingsRoute: typeof PcSettingsRoute
  PcIndexRoute: typeof PcIndexRoute
}

const PcRouteChildren: PcRouteChildren = {
  PcLogRoute: PcLogRoute,
  PcReturnsRoute: PcReturnsRoute,
  PcSettingsRoute: PcSettingsRoute,
  PcIndexRoute: PcIndexRoute,
}

const PcRouteWithChildren = PcRoute._addFileChildren(PcRouteChildren)

interface AirframesIdRouteChildren {
  AirframesIdHistoryRoute: typeof AirframesIdHistoryRoute
  AirframesIdLedgerRoute: typeof AirframesIdLedgerRoute
  AirframesIdMaintenanceRoute: typeof AirframesIdMaintenanceRoute
  AirframesIdMembersRoute: typeof AirframesIdMembersRoute
  AirframesIdPreflightRoute: typeof AirframesIdPreflightRoute
  AirframesIdScheduleRoute: typeof AirframesIdScheduleRoute
  AirframesIdSettingsRoute: typeof AirframesIdSettingsRoute
  AirframesIdIndexRoute: typeof AirframesIdIndexRoute
  AirframesIdFlightsFidRoute: typeof AirframesIdFlightsFidRoute
}

const AirframesIdRouteChildren: AirframesIdRouteChildren = {
  AirframesIdHistoryRoute: AirframesIdHistoryRoute,
  AirframesIdLedgerRoute: AirframesIdLedgerRoute,
  AirframesIdMaintenanceRoute: AirframesIdMaintenanceRoute,
  AirframesIdMembersRoute: AirframesIdMembersRoute,
  AirframesIdPreflightRoute: AirframesIdPreflightRoute,
  AirframesIdScheduleRoute: AirframesIdScheduleRoute,
  AirframesIdSettingsRoute: AirframesIdSettingsRoute,
  AirframesIdIndexRoute: AirframesIdIndexRoute,
  AirframesIdFlightsFidRoute: AirframesIdFlightsFidRoute,
}

const AirframesIdRouteWithChildren = AirframesIdRoute._addFileChildren(
  AirframesIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRoute,
  GuideRoute: GuideRoute,
  LogbookRoute: LogbookRoute,
  PcRoute: PcRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  ScheduleRoute: ScheduleRoute,
  SettingsRoute: SettingsRoute,
  SetupRoute: SetupRoute,
  TransfersRoute: TransfersRoute,
  WelcomeRoute: WelcomeRoute,
  AirframesIdRoute: AirframesIdRouteWithChildren,
  InvitesCodeRoute: InvitesCodeRoute,
  AirframesIndexRoute: AirframesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
